// extracted by mini-css-extract-plugin
export default {"homeText":"Home_homeText__4McUn","title":"Home_title__BabXY","livets":"Home_livets__9zWp+","pussel":"Home_pussel__n+4+R","obi":"Home_obi__hrHPq"};